import { render, staticRenderFns } from "./VisitorConfigList.vue?vue&type=template&id=23a24478&scoped=true&"
import script from "./VisitorConfigList.vue?vue&type=script&lang=js&"
export * from "./VisitorConfigList.vue?vue&type=script&lang=js&"
import style0 from "./VisitorConfigList.vue?vue&type=style&index=0&id=23a24478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a24478",
  null
  
)

export default component.exports